import { Editor } from 'slate'
import { CustomEditor } from 'modules/community/types/custom-editor'

export const withImages = (editor: Editor): CustomEditor => {
  const { isVoid } = editor

  editor.isVoid = element => (element.type === 'image' ? true : isVoid(element))

  return editor
}
